import { LayerDefinition } from './types';
import sunriseDefinition from './sunrise';
import alpenglowDefinition from './alpenglow';
import darkskiesDefinition from './darkskies';
import lenticularDefinition from './lenticular';
import cloudsDefinition from './clouds';
import windsDefinition from './winds';
import hrtempDefinition from './hrtemp';
import smokeDefinition from './smoke';
import dustDefinition from './dust';
import aqiDefinition from './aqi';
import precipDefinition from './precip';
import lightningDefinition from './lightning';
import sunIntensityDefinition from './sun_intensity';
import opticsDewRiskDefinition from './optics_dew_risk';
import seeingDefinition from './seeing';
import valleyFogDefinition from './valley_fog';
import cloudInversionDefinition from './cloud_inversion';
import cloudBaseDefinition from './cloud_base';
import mountainVisibilityDefinition from './mountain_visibility';
import relativeHumidityDefinition from './relative_humidity';
import dewpointDefinition from './dewpoint';
import windchillDefinition from './windchill';
import freezingLevelDefinition from './freezing_level';
import auroraDefinition from './aurora';
import {
  liveRadarDefinition,
  liveLightningDefinition,
  liveSatelliteDefinition,
  liveQpeDefinition,
  liveSnowDefinition,
  liveRtmaWindsDefinition,
  liveRtmaTempDefinition
} from './live_weather';
import sstDefinition from './sst';
import streamflowDefinition from './streamflow';
import bortleDefinition from './bortle';
import solarLunarDefinition from './solar_lunar';
import foliageDefinition from './foliage';
import snowDepthDefinition from './snow_depth';
import {
  alpineWildflowersDefinition,
  desertWildflowersDefinition,
  wildBerriesDefinition
} from './wildflowers';
import wildfiresDefinition from './wildfires';
import droughtDefinition from './drought';
import cpcOutlookDefinition from './cpc_outlook';
import tropicalDefinition from './tropical';
import wxStationsDefinition from './wx_stations';

export * from './types';
export {
  tropicalDefinition,
  cpcOutlookDefinition,
  droughtDefinition,
  sunriseDefinition,
  alpenglowDefinition,
  darkskiesDefinition,
  lenticularDefinition,
  cloudsDefinition,
  windsDefinition,
  hrtempDefinition,
  smokeDefinition,
  dustDefinition,
  aqiDefinition,
  precipDefinition,
  lightningDefinition,
  sunIntensityDefinition,
  opticsDewRiskDefinition,
  seeingDefinition,
  valleyFogDefinition,
  cloudInversionDefinition,
  cloudBaseDefinition,
  mountainVisibilityDefinition,
  relativeHumidityDefinition,
  dewpointDefinition,
  windchillDefinition,
  freezingLevelDefinition,
  auroraDefinition,
  liveRadarDefinition,
  liveLightningDefinition,
  liveSatelliteDefinition,
  liveQpeDefinition,
  liveSnowDefinition,
  liveRtmaWindsDefinition,
  liveRtmaTempDefinition,
  sstDefinition,
  streamflowDefinition,
  bortleDefinition,
  solarLunarDefinition,
  foliageDefinition,
  snowDepthDefinition,
  alpineWildflowersDefinition,
  desertWildflowersDefinition,
  wildBerriesDefinition,
  wildfiresDefinition,
  wxStationsDefinition
};

const layerDefinitionsMap: Record<string, LayerDefinition> = {
  foliage: foliageDefinition,
  alpine_wildflowers: alpineWildflowersDefinition,
  desert_wildflowers: desertWildflowersDefinition,
  wild_berries: wildBerriesDefinition,
  sunrise: sunriseDefinition,
  golden_hour: sunriseDefinition,
  sunrise_forecast: sunriseDefinition,
  sunrise_nowcast: sunriseDefinition,
  alpenglow: alpenglowDefinition,
  alpenglow_forecast: alpenglowDefinition,
  alpenglow_nowcast: alpenglowDefinition,
  goldenhour: alpenglowDefinition,
  darkskies: darkskiesDefinition,
  darkskies_bortle: darkskiesDefinition,
  lenticular: lenticularDefinition,
  lenticular_clouds: lenticularDefinition,
  clouds: cloudsDefinition,
  winds: windsDefinition,
  winds_surface: windsDefinition,
  winds_surface_current: liveRtmaWindsDefinition,
  rtma_winds: liveRtmaWindsDefinition,
  hrtemp: hrtempDefinition,
  hrtemp_current: liveRtmaTempDefinition,
  hrtemp_surface: liveRtmaTempDefinition,
  live_weather_temp_gradient: liveRtmaTempDefinition,
  live_weather_temps: liveRtmaTempDefinition,
  smoke: smokeDefinition,
  smoke_forecast: smokeDefinition,
  dust: dustDefinition,
  dust_forecast: dustDefinition,
  aqi: aqiDefinition,
  aqi_index: aqiDefinition,
  aqi_stations: aqiDefinition,
  wx_stations: wxStationsDefinition,
  precip: precipDefinition,
  precip_forecast: precipDefinition,
  precip_24h: precipDefinition,
  precip_accum: precipDefinition,
  lightning: lightningDefinition,
  thunderstorm: lightningDefinition,
  sun_intensity: sunIntensityDefinition,
  sun_intensity_forecast: sunIntensityDefinition,
  optics_dew_risk: opticsDewRiskDefinition,
  seeing: seeingDefinition,
  valley_fog: valleyFogDefinition,
  cloud_inversion: cloudInversionDefinition,
  cloud_base: cloudBaseDefinition,
  mountain_visibility: mountainVisibilityDefinition,
  relative_humidity: relativeHumidityDefinition,
  dewpoint: dewpointDefinition,
  windchill: windchillDefinition,
  freezing_level: freezingLevelDefinition,
  freezing_level_contours: freezingLevelDefinition,
  aurora: auroraDefinition,
  aurora_viewline: auroraDefinition,
  live_weather_radar: liveRadarDefinition,
  precip_radar: liveRadarDefinition,
  mrms: liveRadarDefinition,
  live_weather_lightning: liveLightningDefinition,
  lightning_live: liveLightningDefinition,
  mrms_lightning: liveLightningDefinition,
  live_weather_satellite: liveSatelliteDefinition,
  satellite_imagery: liveSatelliteDefinition,
  goes: liveSatelliteDefinition,
  live_weather_qpe: liveQpeDefinition,
  rain_accum: liveQpeDefinition,
  live_weather_snow: liveSnowDefinition,
  snow_accum: liveSnowDefinition,
  sst: sstDefinition,
  streamflow: streamflowDefinition,
  streamflow_gauges: streamflowDefinition,
  water_temp: streamflowDefinition,
  snow_depth: snowDepthDefinition,
  snow_stations: snowDepthDefinition,
  bortle: bortleDefinition,
  bortle_baseline: bortleDefinition,
  bortle_baseline_0_4: bortleDefinition,
  light_pollution: bortleDefinition,
  solar_lunar_tools: solarLunarDefinition,
  solar_lunar: solarLunarDefinition,
  wildfires: wildfiresDefinition,
  wildfire_hotspots: wildfiresDefinition,
  drought: droughtDefinition,
  drought_usdm: droughtDefinition,
  cpc_outlook: cpcOutlookDefinition,
  cpc_outlooks: cpcOutlookDefinition,
  tropical: tropicalDefinition,
  tropical_cyclones: tropicalDefinition
};

/**
 * Retrieves the LayerDefinition for a given product key or canonical layer key.
 */
export function getLayerDefinition(layerKey: string): LayerDefinition | undefined {
  if (!layerKey) return undefined;
  return layerDefinitionsMap[layerKey];
}

/**
 * Returns all unique layer definitions in the system.
 */
export function getAllLayerDefinitions(): LayerDefinition[] {
  const unique = new Set<LayerDefinition>();
  Object.values(layerDefinitionsMap).forEach(def => unique.add(def));
  return Array.from(unique);
}
